import { featuresCommon } from './featuresCommon';
import { FeaturesConfig } from '../config';

export const featuresQA: FeaturesConfig = {
  ...featuresCommon,
  baseURL: "https://b2b-app.qa-gcp.fena.co",
  environment: "qa",

  app: {
    ...featuresCommon.app,
    appName: "fena-b2b-wholesale-qagcp",
  },

  cloudConfig: {
    provider: "gcp",
    gcp: {
      projectId: "prj-workload-qa",
      region: "europe-west2",
      integrationStorageBucket: "fena-integrations-api-qa",
      toolkitStorageBucket: "fena-toolkit-backend-qa",
      pubsub: {
        idMapSyncTopic: "batch-job-apps-id-maps-file-sync",
        bulkSyncTopic: "batch-job-apps-bulk-sync",
      },
    },
  },

  sentry: {
    dsn: "https://f0ea596e5a8762438ac64ee2d614cd3d@o1222258.ingest.us.sentry.io/4510467297050624",
  },
};
